var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29823 0.00896263C4.29799 -0.0306273 3.30504 0.194751 2.4199 0.662267C1.53475 1.12978 0.788837 1.82286 0.257648 2.67132C0.152826 2.82012 0.109507 3.00367 0.136729 3.18363C0.163951 3.3636 0.259611 3.52609 0.403752 3.63724L1.66998 4.59502C1.81715 4.70304 2.00008 4.75058 2.18122 4.72794C2.36236 4.7053 2.52796 4.61417 2.64401 4.47325C3.38265 3.54792 3.92648 3.02034 5.07908 3.02034C5.98005 3.02034 7.09207 3.60474 7.09207 4.47325C7.09207 5.13883 6.54823 5.47165 5.65537 5.9749C4.61641 6.55932 3.22031 7.28169 3.22031 9.09176V9.37588C3.22031 9.56317 3.29471 9.74277 3.42714 9.87521C3.55958 10.0076 3.73919 10.082 3.92648 10.082H6.03687C6.22208 10.0778 6.39842 10.0018 6.52867 9.87005C6.65891 9.7383 6.73286 9.56113 6.73492 9.37588V9.20541C6.73492 7.95541 10.4037 7.8986 10.4037 4.50575C10.4362 1.94893 7.78199 0.00896263 5.29823 0.00896263ZM5.00603 10.9343C4.60468 10.9343 4.21235 11.0533 3.87865 11.2763C3.54494 11.4993 3.28486 11.8162 3.13127 12.187C2.97768 12.5578 2.9375 12.9658 3.01579 13.3594C3.09409 13.753 3.28736 14.1146 3.57115 14.3984C3.85494 14.6822 4.21651 14.8755 4.61014 14.9538C5.00377 15.0321 5.41178 14.9919 5.78257 14.8383C6.15336 14.6847 6.47029 14.4246 6.69326 14.0909C6.91624 13.7572 7.03525 13.3649 7.03525 12.9635C7.03525 12.4253 6.82145 11.9092 6.4409 11.5287C6.06034 11.1481 5.54421 10.9343 5.00603 10.9343Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.128821,
    y1: 7.49881,
    x2: 10.3767,
    y2: 7.49881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009CDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.d65e45a58a03b6a5ad8f83f88bf3454c.svg";
export { ForwardRef as ReactComponent };